/**
 * AppLayout
 * =========
 * Root layout shell. Every route renders inside this.
 * Handles: Navbar, BottomNav, modals, and page max-width centering.
 */

import React, { Suspense } from "react";
import { Outlet }          from "react-router-dom";
import { Navbar }    from "./Navbar";
import { BottomNav } from "./BottomNav";
import { Footer }    from "./Footer";
import { SignInModal }      from "@/components/modals/SignInModal";
import { BookDetailModal }  from "@/components/modals/BookDetailModal";
import { useUIStore }    from "@/store/uiStore";

/** Full-screen centered spinner for Suspense fallback */
const PageSpinner: React.FC = () => (
  <div style={{
    display:"flex", alignItems:"center", justifyContent:"center",
    height:"calc(100vh - 116px)", flexDirection:"column", gap:12,
  }}>
    <div style={{
      width:36, height:36,
      border:"3px solid #EAE8F8",
      borderTopColor:"#534AB7",
      borderRadius:"50%",
      animation:"adhvi-spin 0.7s linear infinite",
    }}/>
    <span style={{ fontSize:12, color:"#9B97C8", fontWeight:600 }}>Loading…</span>
  </div>
);

export const AppLayout: React.FC = () => {
  const { openModal } = useUIStore();

  return (
    <div style={{ minHeight:"100vh", background:"#fff", display:"flex", flexDirection:"column" }}>
      <Navbar />

      <main
        id="main-content"
        style={{
          width: "100%",
          flex:  1,          /* grows to fill space → footer always visible at bottom */
        }}
      >
        <Suspense fallback={<PageSpinner />}>
          <Outlet />
        </Suspense>
      </main>

      <Footer />
      <BottomNav />

      {/* Global modals */}
      {openModal === "signIn"     && <SignInModal />}
      {openModal === "bookDetail" && <BookDetailModal />}
    </div>
  );
};
